const prodEnv = {
  adminHubBaseUrl: 'https://admin.atlassian.com',
  mpacBaseUrl: 'https://marketplace.atlassian.com',
  mpacCdnBaseUrl: 'https://marketplace.atlassian.com',
  atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com',
  macBaseUrl: 'https://my.atlassian.com',
  wacBaseUrl: 'https://www.atlassian.com',
  ecosystemCloudEnvKey: 'production'
};
const stagingEnv = {
  adminHubBaseUrl: 'https://admin.stg.atlassian.com',
  mpacBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
  mpacCdnBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
  macBaseUrl: 'https://my.stg.internal.atlassian.com',
  wacBaseUrl: 'https://qa-wac.internal.atlassian.com',
  atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com',
  ecosystemCloudEnvKey: 'production'
};
const localEnv = {
  adminHubBaseUrl: 'https://admin.stg.atlassian.com',
  mpacBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
  mpacCdnBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
  macBaseUrl: 'https://my.stg.internal.atlassian.com',
  wacBaseUrl: 'https://qa-wac.internal.atlassian.com',
  atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com',
  ecosystemCloudEnvKey: 'production'
};
export default config => {
  switch (config.environment) {
    case 'prod':
      return prodEnv;
    case 'staging':
      return stagingEnv;
    case 'local':
      return localEnv;
    default:
      {
        console.error('Unable to configure marketplace env: ' + config.environment);
        return prodEnv;
      }
  }
};